import axios from 'axios'
import url from '@/URL.js'
import router from '@/router/index'

function verifyToken(err) {
    if(err.response.status === 401) {
        localStorage.removeItem('adminToken')
        router.push('/admin/login')
    }
}
export const state = {
    loading:false,
    error:'',
    success:'',
    editors:[],
    users:[],
    admins:[]
}

export const mutations = {
 LOADING(state, request) {
     state.loading = request
 },
 ERROR(state, request) {
     state.error = request
     setTimeout(function( ){
        state.error = null
     },4000)
 },
 SUCCESS(state,request) {
     state.success = request;
     setTimeout(function( ){
        state.success = null
     },4000)
 },


 ADD_EDITORS(state,editors) {
    state.editors= editors
 },
 APPROVE(state,{key, editor}) {
  state.editors.splice(key,1)
  state.editors.push(editor)
    
 }, 
 SUSPEND(state,{key, editor,fromUser}) {
    state.editors.splice(key,1)
    state.editors.push(editor)
   
    if(fromUser) {
        state.users.splice(key,1)
        state.users.push(editor) 
    }
   }, 
 ADD_USERS(state,users) {
    state.users = users
},
ADD_ADMIN(state, admin) {
    state.admins.pus(admin)
}
}

export const actions = {
    async getUsers({commit}){
        commit('LOADING', true)
          try {
              const {data, status} = await axios.get(`${url()}/api/actioncommons/all-contributors`,{
              headers: {
                Authorization: `${localStorage.getItem('adminToken')}`
            }})
            console.log('response', data)
              if(status === 200) {
                  commit('ADD_USERS', data)
                  commit('LOADING', false)
              }
    
          } catch( err) {
              if(err.response.status === 400){
                  commit('ERROR','An Error Occured Try Again!')
                  commit('LOADING',false)
              }
              verifyToken(err)

              commit('LOADING', false)
            
             console.log('Network Error', err.response.data)
          }
          
      },
    //fetch all editors
    async getEditors({commit}) {
        commit('LOADING',true)

            try {
                const {data, status} = await axios.get(`${url()}/api/actioncommons/all-editors`, {
                    headers: {
                        Authorization: `${localStorage.getItem('adminToken')}`
                    }
                })
                //console.log('response', data)
                if(status === 200) {
                    commit('LOADING', false)
                    console.log('data',data)
                    commit('ADD_EDITORS',data)
                }
            }catch( err ) {
                //console.log(err)
                verifyToken(err)
                commit('LOADING', false) 
            }
        
    },
    // approve agreement
   async approve({commit}, {id, key}){
        commit('LOADING', true)
          try {
                axios.defaults.headers.common['Authorization'] = `${localStorage.getItem('adminToken')}`;
                const {data, status} = await axios.patch(`${url()}/api/actioncommons/editor/${id}/approve`)
                console.log('response', data)
                    if(status === 200) {
                        commit('LOADING', false)
                        commit('SUCCESS', 'Approved successfully')
                        commit('APPROVE', {key : key, editor:data.editor})
                    }
            } catch( err ) {
                console.log(err)
                verifyToken(err)
            }
            
    },
    async suspend({commit}, {id, key,value, fromUser}){
        commit('LOADING', true)
          try {
                axios.defaults.headers.common['Authorization'] = `${localStorage.getItem('adminToken')}`;
                const {data, status} = await axios.patch(`${url()}/api/actioncommons/suspend-account/${id}`,{
                    'suspend':value
                } )
                console.log('response', data)
                    if(status === 200) {
                        commit('LOADING', false)
                        commit('SUCCESS', data.message)
                        commit('SUSPEND', {key:key, editor:data.editor, fromUser})
                    }
            } catch( err ) {
                console.log(err.response)
                verifyToken(err)
            }
            
    },
    async createAdmin({commit}, payload) {
        commit('LOADING', true)
          try {
                const {data, status} = await axios.post(`${url()}/api/actioncommons/subadmin/create`, payload,
                {
                    headers: {
                        Authorization: ` ${localStorage.getItem('adminToken')}`
                    }
                })
                 console.log('admins',data)
                    if(status === 201) {
                        commit('LOADING', false)
                        commit('SUCCESS', 'Admin Created Successfully')
                        commit('ADD_ADMIN',data)
                    }
            } catch( err ) {
                console.log(err)
                //verifyToken(err)
                if(err.response.status = 400) {
                    commit('LOADING',false)
                    commit('ERROR', 'Email is already created')
                }
                commit('LOADING', false) 
            }
    },
    async changePassword({commit}, {password, confirm_password}) {
        if(password !== confirm_password) {
            commit('LOADING', false) 
            commit('ERROR', 'Password Does Not Match')
            return ;
        }
        commit('LOADING', true)
          try {
                axios.defaults.headers.common['Authorization'] = `${localStorage.getItem('adminToken')}`;
                //console.log('adminToken', loacalStorage.getItem('adminToken'))
                const {data, status} = await axios.patch(`${url()}/api/actioncommons/admin-change-password`, {password:password})
                console.log('response', data)
                    if(status === 200) {
                        commit('LOADING', false)
                        commit('SUCCESS', 'Your Password has been changed')
                    }
            } catch( err ) {
                console.log(err)
                verifyToken(err)
                commit('LOADING', false) 
            }
    }


}

export const getters = {

}